$(document).ready(function() {



	const swiper = new Swiper('.swiper', {

		// Optional parameters

		direction: 'horizontal',

		loop: false,

		autoHeight: false,

		slidesPerView: 2,

		navigation: false,

		breakpoints: {

			480: {

				slidesPerView: 2,

				navigation: true,

			},

			780: {

				slidesPerView: 3,

			},

			880: {

				slidesPerView: 4,

			},

			1200: {

				slidesPerView: 5,

			},

			1300: {

				slidesPerView: 6,

			},

			1400: {

				slidesPerView: 7,

			},

			1600: {

				slidesPerView: 8,

			},

		},



		// Navigation arrows

		navigation: {

			nextEl: '.swiper-button-next',

			prevEl: '.swiper-button-prev',

		},



		// And if we need scrollbar

		scrollbar: {

			el: '.swiper-scrollbar',

		},

	});



	const swiperRec = new Swiper('.swiperRec', {

		slidesPerView: "auto",

		centeredSlides: true,

		// spaceBetween: 30,
		autoHeight: false,

		breakpoints: {

			480: {

				slidesPerView: 1,

				centeredSlides: false,

				grid: {

					fill: 'row',

					rows: 1,

				},

				pagination: {

					el: ".swiper-pagination",

					clickable: true,

				},

			},

			992: {

				slidesPerView: 2,

				centeredSlides: false,

				grid: {

					fill: 'row',

					rows: 1,

				},

				pagination: {

					el: ".swiper-pagination",

					clickable: true,

				},

			},

			1200: {

				slidesPerView: 3,

				centeredSlides: false,

				grid: {

					fill: 'row',

					rows: 1,

				},

				pagination: {

					el: ".swiper-pagination",

					clickable: true,

				},

			},

		},

	});





});